import {  SeferPetachProvider         }       from "SeferPetach/SeferPetachProvider";
import {  BrowserRouter, 
          Route, 
          Routes                     }        from "react-router-dom";
import {  DefaultPage                }        from "Pages/Default/default_pg";
import {  HomePage                   }        from "Pages/Home/home_pg";
import {  Layout                     }        from "Pages/Default/sys_pg";
import {  NotFound                   }        from "Pages/NotFound/notfound_pg";
import {  UserConfigPage             }        from "Pages/UserConfig/user_config_pg";
import {  MainContent                }        from "SeferPetach/staticContent";
import {  UsersPage                  }        from "Pages/Users/users_pg";
import {  ConfigPage                 }        from "Pages/Config/config_pg";
import {  ContentPage                }        from "Pages/Content/content_pg";
import {  ContentScriptPage          }        from "Pages/ContentScript/content_script_pg";
import {  AdminPage                  }        from "Pages/Admin/admin_pg";
import {  BindUsersPage              }        from "Pages/BindUsers/bind_users_pg";
import {  FeedBackPage               }        from "Pages/FeedBack/feedback_pg";
import {  FeedBackReportPage         }        from "Pages/FeedBack/feedback_report_pg";
import {  GamePlayer                 }        from "Pages/DevArea/fun";
import {  Windows95                  }        from "Pages/Setup/setup";


function App() {
  return (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<DefaultPage/>}>
            <Route index  element={<HomePage/>}/>
            <Route path="home"              element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <MainContent/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />
            <Route path="user_config"       element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <UserConfigPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />
            <Route path="users"             element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <UsersPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />
            <Route path="bind_users"        element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <BindUsersPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />
            <Route path="config"            element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <ConfigPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />
            <Route path="content"           element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <ContentPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />
            <Route path="content_script"    element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <ContentScriptPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />            
            <Route path="adm"               element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <AdminPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />          
            <Route path="feedback"          element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <FeedBackPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />    
            <Route path="report"          element={
                                            <SeferPetachProvider>
                                            <Layout>
                                                <FeedBackReportPage/>
                                            </Layout>
                                            </SeferPetachProvider>
                                            }
            />                                                             
            <Route path="setup"          element={
                                            <SeferPetachProvider>
                                                <Windows95/>
                                            </SeferPetachProvider>
                                            }
            />
            <Route path="dev_area"          element={
                                            <SeferPetachProvider>
                                                <GamePlayer/>
                                            </SeferPetachProvider>
                                            }
            />
            <Route path="*"             element={<NotFound/>}/>
            </Route>
      </Routes>
    </BrowserRouter>
  );
}
export default App;